export enum Ga4EventPaymentType {
    BLIK_ONLINE = 'BLIK_ONLINE',
    CARD = 'CARD',
    STANDARD_TRANSFER = 'STANDARD_TRANSFER',
    PARTNER = 'PARTNER',
}
